import { useState } from 'react'
import Icon from '@forwardflow/ui/Icons'
import dayjs from 'dayjs'
import { message } from 'antd'
import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'

interface MessageItemProps {
   item: any
   leadDetails: any
}

export const InitialLeadSummaryItem: React.FC<MessageItemProps> = ({
   item,
   leadDetails,
}) => {
   const { data: user } = useAuthUser({ revalidateOnMount: true })
   const stripHtml = (html: string) => {
      const tmp = document.createElement('DIV')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
   }
   const [isExpanded, setIsExpanded] = useState(false)
   const toggleExpand = () => {
      setIsExpanded(!isExpanded)
   }
   const handleCopy = () => {
      navigator.clipboard.writeText(item?.stepId).then(() => {
         message.success('Copied to clipboard')
      })
   }

   return (
      <div className="bg-[#D9D9D9]/10 text-[14px] -mb-4">
         {user?.email === 'operator@forward-flow.com' && item?.stepId && (
            <div className="text-[11px] text-white/70 px-8 pt-3 flex gap-x-4">
               <span
                  className="cursor-pointer select-all"
                  title="Click to copy"
                  onClick={handleCopy}
               >
                  Step Id:{' '}
                  <span className="text-[12px] font-medium">
                     {item?.stepId}
                  </span>
               </span>
               {item?.phase && (
                  <span
                     className="cursor-pointer select-all"
                     title="Click to copy"
                     onClick={handleCopy}
                  >
                     Phase:{' '}
                     <span className="text-[12px] font-medium">
                        {item?.phase}
                     </span>
                  </span>
               )}
            </div>
         )}
         <div className="flex items-center justify-between px-8 py-3 border-b border-white/20">
            <p>
               Lead Discovered -{' '}
               {item?.campaignPhase ?? leadDetails?.stageInfo?.name} campaign
            </p>
            {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
         </div>
         <div
            className="flex items-center gap-x-6 px-8 py-4 text-[14px]  justify-between cursor-pointer"
            onClick={toggleExpand}
         >
            <div
               className={`${
                  isExpanded ? '' : 'line-clamp-1'
               } transition-all duration-200`}
            >
               {stripHtml(item?.content)}
            </div>
            <Icon
               name="arrow-down"
               className={`${isExpanded ? '-rotate-180' : ''}`}
            />
         </div>
      </div>
   )
}
